<div
    class="osm-with-marker-container"
    leaflet
    [leafletOptions]="mapOptions()"
    (leafletMapReady)="onMapLoaded($event)"
></div>
